import { useEffect, useState } from 'react';
import styles from './index.module.scss';
import { LANGUAGE, LocalStorageKey, ROUTER_MAP } from '@/types';
import { localStorageHelper } from '@/utils/localCache';
import { useStore } from '@/store';
import { useLocation, useRequest } from 'ice';
import service from '@/request/service';
import { getQueryStringByName } from '@/utils/helper';
import { externalLangType, changeLangType, getCinemaCurrencySignType } from '@/locales';
// import { showSideBarRouterList } from '@/hooks/useSideBar';
import { Icons } from '@/packages';
import { SupportLanguageType } from '@/types/cinema/detail';
function addLangParam(url, lang) {
  // 使用URL类来处理URL和参数
  let urlObject = new URL(url);

  // 给指定的searchParam（这里是'lang'）添加新值。
  // 如果该参数已存在，那么其值会被新值替换
  urlObject.searchParams.set('lang', lang);

  // 返回修改后的URL字符串
  return urlObject.href;
}

export default function Language() {
  const { baseObj, setBaseObj } = useStore();
  const [show, setShow] = useState(false);
  const [showLanguage, setShowLanguage] = useState(false);
  const location = useLocation();
  const [supportLanguages, setSupportLanguages] = useState<SupportLanguageType[]>([]);
  // 获取座位号配置信息
  const { } = useRequest(service.getCinemaCurrencySign, {
    manual: false,
    defaultParams: [
      {
        channelCode: baseObj.wapid,
        cinemaLinkId: baseObj.cinema.cinemaLinkId,
      },
    ],
    onSuccess: (res) => {
      const data = res?.result?.bizValue?.filter((item) => {
        return item.cinemaLinkId === baseObj.cinema.cinemaLinkId;
      })[0];
      // 多语言字段转化
      let lang = data.supportLanguages.map((item) => {
        let code = getCinemaCurrencySignType[item.languageCode];
        if (code) {
          return {
            languageCode: code,
            languageName: item.languageName,
          };
        }
      }).filter(item => item);
      setSupportLanguages(lang as SupportLanguageType[]);
      localStorageHelper.set(LocalStorageKey.seatSpliceRuleInfo, data.seatSpliceRuleInfo);
    },
  });

  const changeLocale = (locale: string) => {
    setBaseObj({
      ...baseObj,
      currentLanguage: locale,
    });
    localStorageHelper.set(LocalStorageKey.lang, locale);
    const currentURL = window.location.href;
    const urlLang: any = getQueryStringByName('lang') || '';
    // 如果链接上有参数，则依赖链接上的语种;
    if (urlLang) {
      let newURLWithLang = addLangParam(currentURL, changeLangType[locale]);
      window.location.replace(newURLWithLang);
    } else {
      window.location.reload();
    }
  };

  const [localeText, setLocaleText] = useState('');

  const updateLocaleText = (locale: string) => {
    const urlLang: any = getQueryStringByName('lang') || '';
    // 如果链接上有参数，则依赖链接上的语种;
    setBaseObj({
      ...baseObj,
      currentLanguage: urlLang || locale,
    });
    if (urlLang) {
      setLocaleText(LANGUAGE[externalLangType[urlLang]]);
      return;
    }
    setLocaleText(LANGUAGE[locale]);
  };

  useEffect(() => {
    if (
      [ROUTER_MAP.HOME, ROUTER_MAP.SCREEN, ROUTER_MAP.ACTIVITY_AND_VIP, ROUTER_MAP.FILM].includes(
        location.pathname as ROUTER_MAP,
      )
    ) {
      setShowLanguage(true);
    } else {
      setShowLanguage(false);
    }
    updateLocaleText(localStorageHelper.get(LocalStorageKey.lang) || baseObj.currentLanguage);
  }, [location]);

  const openLanguage = () => {
    if (showLanguage) {
      if (
        ![ROUTER_MAP.HOME, ROUTER_MAP.SCREEN, ROUTER_MAP.ACTIVITY_AND_VIP, ROUTER_MAP.FILM].includes(
          location.pathname as ROUTER_MAP,
        )
      ) {
        return;
      }
      setShow(!show);
    }
  };

  if (!showLanguage) {
    return null;
  }

  return (
    <div onClick={openLanguage} className={styles.language}>
      <div className={styles.language_icon}>
        <Icons.IconDengluyeYuyanqiehuan className={styles.icon} />
        <span className={'h5-none pad-none'}>{localeText}</span>
      </div>
      {show && showLanguage ? (
        <>
          <div className={styles.mask} />
          <div className={styles.list}>
            <div className={styles.language_list}>
              <span className={styles.triangle_up} />
              <ul role="list">
                {supportLanguages?.map((item) => {
                  if (!item) return null;

                  return (
                    <li
                      key={item.languageCode}
                      className="cursor-pointer"
                      onClick={() => changeLocale(item.languageCode)}
                    >
                      <span>{LANGUAGE[item.languageCode]}</span>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </>
      ) : null}
    </div>
  );
}
